<template>
<div class="home">
    <MobilePop v-show="isMobile" />
    <div class="home-background"></div>
    <div class="center-wrapper">
        <div class="home-info">
            <h1>Greenham<br> <span>W</span>omen<br> Digital</h1>
            <p>Greenham women led the world in questioning war and exploring women's rights.</p>
            <p>Delve into an historic treasure hunt, and let their stories inspire you.</p>
        </div>
    </div>
</div>
</template>

<script>
import MobilePop from "@/components/MobilePop"
export default {
    name: 'Home',
    components: {
        MobilePop,
    },
    data() {
        return {
            isMobile: null
        }
    },
    methods: {
        evaluateScreen() {
            this.isMobile = document.documentElement.clientWidth < 769
        }
    },

    mounted() {
        this.evaluateScreen()
    },

    created() {
        this.evaluateScreen()
        window.addEventListener('resize', this.evaluateScreen.bind(this), false)

    }


}
</script>

<style scoped>
.home {
    overflow: hidden;
}

.home-background {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 0;
    background-color: var(--mid);
    background-image: url(/images/greenham-home-kh.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-blend-mode: soft-light;
    opacity: .4;
}

.home-info {
    text-align: center;
    color: var(--darkest);
    z-index: 1;
}

.home-info h1 {
    line-height: 1.1;
    letter-spacing: -0.02em;
    font-size: 17vw;
    margin: 0 0 .5em;
}

/* TO FIX BAGNARD BAD KERNING */
/* .home-info h1 span {
    letter-spacing: -0.13em;
} */

.home-info p {
    margin: 0 auto 1em;
    line-height: 1.15;
}

@media screen and (min-width: 660px) {
    .home-info h1 {
        font-size: 10vw;
        margin: .5em 0 .2em;
    }

    .home-info p {
        font-size: 1.3em;
        width: 26em;
    }
}

@media screen and (min-width: 660px) and (max-height: 700px) {
    .home-info h1 {
        font-size: 3.5em;
    }
}
</style>
